import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import { User, initialUserInfo } from "../../../model/Users";
import { Company } from "../../../model/Companies";
import { SystemSetting } from "../../../model/SystemSetting";

export type UserIdCardPDFProps = {
  usersList: User[];
  company: Company;
  systemSetting?: SystemSetting;
  matiTapData: {url: string, qr:any};
}

export const UserIdCardPDF = ({
  usersList,
  company,
  systemSetting,
  matiTapData,
}: UserIdCardPDFProps) => {

  Font.register({
		family: "BIZUDPGothic",
		fonts: [
			{
				src: "/fonts/BIZUDPGothic-Regular.ttf",
			},
			{
				src: "/fonts/BIZUDPGothic-Bold.ttf",
				fontWeight: "bold",
			},
		],
	});

  const styles = StyleSheet.create({
		page: {
      display: 'flex',
			flexDirection: 'column',
			backgroundColor: '#FFFFFF',
			fontFamily: "BIZUDPGothic",
		},
    page2: {
      flex: 1,
			flexDirection: 'row',
			backgroundColor: '#FFFFFF',
			fontFamily: "BIZUDPGothic",
      flexWrap: 'wrap',
      paddingTop: 30,
      paddingLeft: 50,
		},
		header: {
			fontSize: 24,
      position: 'absolute', 
      left: '5%',
      marginTop: 30,
      textAlign: 'left',
		},
    pageCount: {
      textAlign: 'right', 
      fontSize: 18, 
      position: 'absolute', 
      left: '85%', 
      marginTop: 30,
    },
    subHeader1: {
      fontSize: 18, 
      textAlign: 'left', 
      marginLeft: 30, 
      marginTop: 69,
    },
    subHeader2: {
      fontSize: 18, 
      textAlign: 'left', 
      marginLeft: 30, 
      marginTop: 7.5,
    },
    listContent: {
      width: '100%',
      textAlign: 'left',
      marginTop: 20
		},
    contentText: {
      fontSize: 16, 
      marginBottom: 3, 
      marginLeft: 30,
		},
    contentText2: {
      display: 'flex', 
      marginBottom: 4, 
      marginLeft: 30,
    },
    contentText3: {
      marginTop: 10, 
      marginLeft: 10,
    },
    line1: {
      width: 10, 
      height: 10, 
      borderTop: '1px solid #808080', 
      borderLeft: '1px solid #808080', 
      float:'left'
    },
    line2: {
      width: 10, 
      height: 10, 
      borderLeft: '1px solid #808080', 
      borderBottom: '1px solid #808080', 
      position: 'absolute', 
      top: '95%'
    },
    line3: {
      width: 10, 
      height: 10, 
      borderLeft: '1px solid #808080', 
      position: 'absolute', 
      top: '95%'
    },
    line4: {
      width: 10, 
      height: 10, 
      borderTop: '1px solid #808080', 
      position: 'absolute', 
      top: '0%', 
      left: '96%'
    },
    line5: {
      width: 10, 
      height: 10, 
      borderTop: '1px solid #808080', 
      borderRight: '1px solid #808080', 
      position: 'absolute', 
      top: '0%', 
      left: '96%'
    },
    line6: {
      width: 10, 
      height: 10, 
      borderRight: '1px solid #808080', 
      position: 'absolute', 
      top: '95%', 
      left: '96%'
    },
    line7: {
      width: 10, 
      height: 10, 
      borderBottom: '1px solid #808080', 
      position: 'absolute', 
      top: '95%', 
      left: '96%'
    },
    line8: {
      width: 10, 
      height: 10, 
      borderRight: '1px solid #808080', 
      borderBottom: '1px solid #808080', 
      position: 'absolute', 
      top: '95%', 
      left: '96%'
    },
    content: {
      width: '86mm',
      height: '54mm',
      display: 'flex'
    },
    text1: {
      fontSize: 12,
      marginBottom: 4,
      marginLeft: 12,
      marginTop: 5,
    },
    text2: {
      fontSize: 12,
      marginBottom: 4,
      marginLeft: 30,
    },
    text3: {
      fontSize: 10,
    },
    qrCode: {
      width: 62,
      height: 62,
      marginLeft: 95,
    },
    qrCode2: {
      width: 62, 
      height: 62, 
      position: 'absolute', 
      marginTop: 12, 
      left: '10%', 
      top: '60%',
    },
    image: {
      width: 120, 
      height: 42, 
      position: 'absolute', 
      marginTop: 28, 
      left: '38%', 
      top: '60%',
    },
    url: {
      fontSize: 11, 
      marginLeft: 32, 
      marginBottom: 50, 
      position: 'absolute', 
      top: '68%',
    },
    space: {
      marginBottom: 7.5,
    }
	});

  // 利用者情報の一覧を分割（一覧表示）
  const divisionList = () => {
    const totalPages = Math.ceil(usersList.length / 30);
    const dividedList = Array.from({length : totalPages},(_, pageIndex) =>
      usersList.slice(pageIndex * 30, (pageIndex + 1) * 30)
    );
    return dividedList;
  }

  // 利用者情報の一覧を分割（IDカードの表面）
  const divisionData = () => {
    const totalPages = Math.ceil(usersList.length / 10);
    const dividedUsers = Array.from({length : totalPages},(_, pageIndex) =>
      usersList.slice(pageIndex * 10, (pageIndex + 1) * 10)
    );
    const count = dividedUsers.length;
    for(let i = 0; i < 10; i++){
      if(!dividedUsers[count - 1][i]){
        dividedUsers[count - 1].push(initialUserInfo);
      }
    }
    return dividedUsers;
  }

  //　トンボのスタイル割り当て
  const contentStyle = () => {
    return styles.line1;
  }
  const contentStyle2 = (index: number) => {
    if(index === 9 || index === 10){
      return styles.line2;
    }
    return styles.line3;
  }
  const contentStyle3 = (index: number) => {
    if(index === 1 || index === 3 || index === 5 || index === 7 || index === 9){
      return styles.line4;
    }
    return styles.line5;
  }
  const contentStyle4 = (index: number) => {
    if(index === 2 || index === 4 || index === 6 || index === 8){
      return styles.line6;
    }else if(index === 9){
      return styles.line7;
    }else if(index === 10){
      return styles.line8;
    }
    return {};
  }

  // 最大桁数を判定
  const nameDisp = (name: string, itemName: string) => {
    const kanaRegex = new RegExp(/[ｦ-ﾟ]/) 
    let nameLength = 0;
    let newName = "";
    for(let i = 0; i < name.length; i++){
      // 半角カナ・半角英数を判定
      if(name[i].match(kanaRegex)){
        nameLength = nameLength + 0.5;
      }else if(name[i].match(/^[a-z0-9０-９]*$/)){
        nameLength = nameLength + 0.875;
      }else{
        nameLength = nameLength + 1;
      }

      if((itemName === 'userName' && nameLength <= 14) || 
        (itemName === 'companyTitle' && nameLength <= 15) || 
        (itemName === 'companyName' && nameLength <= 18)
      ){
        newName = newName + name[i];
      }
    }
    return newName;
  }

  // 裏面の表示
  const backDisp =  () => {
    let list = [];
    for (let i = 0; i < 10; i++) {
      list.push(
        <View style={styles.content}>
          <Text style={contentStyle()}></Text>
          <Text style={contentStyle3(i + 1)}></Text>
          <View style={styles.contentText3}>
            <Image src={`${matiTapData.qr}`} style={styles.qrCode2}></Image>
            <Image src={"/image/machitappu.png"} style={styles.image}></Image>
          </View>
          <Text style={styles.url}>{matiTapData.url}</Text>
          <Text style={contentStyle2(i + 1)}></Text>
          <Text style={contentStyle4(i + 1)}></Text>
        </View>
      ); 
    }
    return <>{list}</>;
  }

  return (
    <Document>
      {divisionList().map((items, index) => {
        return(
          <>
            <Page size="A4" style={styles.page}>
              <View>
                <Text style={styles.header}>利用者IDカード一覧</Text>
                {divisionList().length === 1 ? (
                  <>
                    <Text style={styles.pageCount}>{usersList.length}件</Text>
                  </>
                ) : (
                  <>
                    <Text style={styles.pageCount}>{`（${index + 1}／${divisionList().length}）`}</Text>
                  </>
                )}
                <Text style={styles.subHeader1}>{company.displayId.replace(/(\d)(?=(\d{4})+(?!\d))/g, '$1 ')}</Text>
                {/* <Text style={styles.subHeader2}>{company.name.substring( 0, 18 )}</Text> */}
                <Text style={styles.subHeader2}>{nameDisp(company.name, "companyName")}</Text>
              </View>
              <View style={styles.listContent}>
                {items.map((item, i) => {
                  return(
                    <>
                      <Text style={styles.contentText}>
                        {/* {(item.displayId? item.displayId.replace(/(\d)(?=(\d{4})+(?!\d))/g,'$1 ') : "") + "　　　　　　　　　" + (item.lastName? item.lastName.substring( 0, 14 ) : "")} */}
                        {(item.displayId? item.displayId.replace(/(\d)(?=(\d{4})+(?!\d))/g,'$1 ') : "") + "　　　　　　　　　" + (item.lastName? nameDisp(item.lastName, "userName") : "")}
                      </Text>
                      {(i + 1) % 5 === 0  && i + 1 !== 30? 
                        <><Text style={styles.space}></Text></> : <></>
                      }
                    </>
                  );
                })}
              </View>
            </Page>
          </>
        );
      })}
      {divisionData().map((items) => {
        return(
          <>
            <Page size="A4" style={styles.page2}>
              {items.map((item, index) => {
                return(
                  <>
                    <View style={styles.content}>
                      <View>
                        <Text style={contentStyle()}></Text>
                        <Text style={contentStyle3(index + 1)}></Text>
                      </View>
                      {item.tenantId? (
                        <>
                          {/* <Text style={styles.text1}>{(systemSetting?.subTitle)? systemSetting?.subTitle.substring( 0, 15 ) : ""}</Text> */}
                          <Text style={styles.text1}>{(systemSetting?.subTitle)? nameDisp(systemSetting.subTitle, "companyTitle") : ""}</Text>
                          <Text style={styles.text2}>団体番号　&nbsp;：{company.displayId.replace(/(\d)(?=(\d{4})+(?!\d))/g,'$1 ')}</Text>
                          <Text style={styles.text2}>利用者番号：{item.displayId? item.displayId.replace(/(\d)(?=(\d{4})+(?!\d))/g,'$1 ') : ""}</Text>
                          {item.lastName && item.lastName.length <= 8 ? 
                            <>
                              <Text style={styles.text2}>氏名　　　　&nbsp;：{item.lastName}</Text>
                            </> 
                            : 
                            <>
                              <Text style={styles.contentText2}>
                                <Text style={styles.text2}>氏名　　　　&nbsp;：</Text>
                                {/* <Text style={styles.text3}>{item.lastName ? item.lastName.substring( 0, 14 ) : ""}</Text> */}
                                <Text style={styles.text3}>{item.lastName ? nameDisp(item.lastName, "userName") : ""}</Text>
                              </Text>
                            </>
                          }
                          <Image src={`${item.qrData}`} style={styles.qrCode}></Image>
                        </>
                      ) : (
                        <></>
                      )}
                      <Text style={contentStyle2(index + 1)}></Text>
                      <Text style={contentStyle4(index + 1)}></Text>
                    </View>
                  </>
                )
              })}
            </Page>
          </>
        );
      })}
      <Page size="A4" style={styles.page2}>
        {backDisp()}
      </Page>
    </Document>
  )
}